import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material'

export const useImageStyles = makeStyles<Theme>((theme) => ({
    imageSize: {
      width: '12.3rem',
      height: '10.3rem',
    }
}))
